import PropTypes from 'prop-types';
import { useDownloadProgram } from './DownloadProgramContext';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function DownloadProgramLink({ children }) {
  const { onShowModal } = useDownloadProgram();

  return (
    <button
      className="font-bold text-lg text-gray-900 hover:text-gray-700 text-center focus:outline-none inline-flex items-center space-x-2"
      onClick={onShowModal}
      type="button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 opacity-50"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
      <div>{children}</div>
    </button>
  );
}

DownloadProgramLink.defaultProps = defaultProps;
DownloadProgramLink.propTypes = propTypes;
